export type SupplierRow = {
  key: string;
  name: string;
  addressLine1: string;
  addressLine2: string;
  defaultMoq: string;
  defaultMsq: string;
  defaultLeadTime: string;
  asins: string[];
};

export const supplierData: SupplierRow[] = [
  {
    key: "A",
    name: "Supplier A",
    addressLine1: "Wales, UK",
    addressLine2: "90 Orange St, EC1A 1AH",
    defaultMoq: "21",
    defaultMsq: "4_574",
    defaultLeadTime: "40d",
    asins: ["B0D15LQ983", "B0D8WPPF56", "B0D5MNJWR9"],
  },
  {
    key: "B",
    name: "Supplier B",
    addressLine1: "London, UK",
    addressLine2: "81 Grange Ave, EC1A 1AA",
    defaultMoq: "862",
    defaultMsq: "20",
    defaultLeadTime: "25d",
    asins: ["B0D5MNJWR9", "B0D15LQ983", "B0D8WPPF56"],
  },
  {
    key: "C",
    name: "Supplier C",
    addressLine1: "Wales, UK",
    addressLine2: "87 Vernon Tce, EC8B 1BE",
    defaultMoq: "40",
    defaultMsq: "50",
    defaultLeadTime: "30d",
    asins: ["B0D15LQ983", "B0D5MNJWR9"],
  },
  {
    key: "D",
    name: "Supplier D",
    addressLine1: "Birmingham, UK",
    addressLine2: "88 Lamington St, EC8B 1BP",
    defaultMoq: "31",
    defaultMsq: "862",
    defaultLeadTime: "22d",
    asins: ["B0D15LQ983", "B0D5MNJWR9", "B0D8WPPF56", "B0DF36CMY8"],
  },
  {
    key: "E",
    name: "Supplier E",
    addressLine1: "London, UK",
    addressLine2: "81 Grange Ave, EC1A 1AA",
    defaultMoq: "26",
    defaultMsq: "1_569",
    defaultLeadTime: "30d",
    asins: ["B0DG36XHMH"],
  },
  {
    key: "F",
    name: "Supplier F",
    addressLine1: "Wales, UK",
    addressLine2: "90 Orange St, EC1A 1AH",
    defaultMoq: "421",
    defaultMsq: "32",
    defaultLeadTime: "32d",
    asins: ["B0D15LQ983", "B0D8WPPF56", "B0D5MNJWR9", "B0DG36XHMH"],
  },
  {
    key: "G",
    name: "Supplier G",
    addressLine1: "Birmingham, UK",
    addressLine2: "88 Lamington St, EC8B 1BP",
    defaultMoq: "82",
    defaultMsq: "952",
    defaultLeadTime: "40d",
    asins: ["B0D15LQ983", "B0D5MNJWR9"],
  },
  {
    key: "H",
    name: "Supplier H",
    addressLine1: "London, UK",
    addressLine2: "81 Grange Ave, EC1A 1AA",
    defaultMoq: "716",
    defaultMsq: "71",
    defaultLeadTime: "60d",
    asins: ["B0D15LQ983", "B0D5MNJWR9", "B0D8WPPF56", "B0DF36CMY8"],
  },
  {
    key: "I",
    name: "Supplier I",
    addressLine1: "Birmingham, UK",
    addressLine2: "88 Lamington St, EC8B 1BP",
    defaultMoq: "83",
    defaultMsq: "272",
    defaultLeadTime: "32d",
    asins: ["B0D5MNJWR9", "B0D15LQ983", "B0D8WPPF56"],
  },
  {
    key: "J",
    name: "Supplier J",
    addressLine1: "Wales, UK",
    addressLine2: "87 Vernon Tce, EC8B 1BE",
    defaultMoq: "794",
    defaultMsq: "65",
    defaultLeadTime: "60d",
    asins: ["B0DG36XHMH"],
  },
];
